import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Row, Col } from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link";

export const ImageWithTextBanner = ({
    className,
    title,
    heading,
    content,
    image,
    buttonLink,
    buttonTitle,
    buttonNewTab,
}) => {

    return (
        <section className={`${styles.root} ${className}`}>
            <Row className="m-0 align-items-stretch">
                <Col md={8} className="left-column d-flex align-items-center py-5">
                    <div>
                        {title && (
                            <h2 className={`${heading} fw-bold mb-4`}>
                                {title}
                            </h2>
                        )}
                        {content &&
                            <div className="mb-4" dangerouslySetInnerHTML={{ __html: content }} />
                        }
                        {buttonLink && buttonTitle &&
                            <div>
                                <Link href={buttonLink}>
                                    <a className="tertiaryBtn no-arrow" target={buttonNewTab ? '_blank' : '_self'}>
                                        {buttonTitle}
                                    </a>
                                </Link>
                            </div>
                        }
                    </div>
                </Col>
                <Col md={4} className="right-column p-0">
                    <figure className="ratio ratio-4x3 m-0 h-100">
                        <SourceFlowImage
                            src={image?.url ? image?.url : "/site-assets/placeholders/img-placeholder.jpg"}
                            size={"600x600"}
                            alt={image?.alt}
                            className="card-img bg-white h-100"
                        />
                    </figure>
                </Col>
            </Row>
        </section>
    )
}

export default ImageWithTextBanner;
